import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "../../mock/mock";
import { trackEvent } from "../../lib/analytics";

const links = [
  { href: "#program", label: "Program" },
  { href: "#schedule", label: "Schedule" },
  { href: "#show-night", label: "Show Night" },
  { href: "#investment", label: "Investment" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-40 transition-colors duration-300 ${scrolled ? "bg-[#fdfaf5]/95 backdrop-blur border-b border-[#e9dfce]" : "bg-[#fdfaf5]"}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#top" className="flex flex-col leading-none group">
          <span className="font-serif-display text-2xl md:text-[28px] text-[#7a1e2f] tracking-tight">
            Take The Stage
          </span>
          <span className="mt-1 text-[10px] md:text-[11px] tracking-[0.28em] uppercase text-[#1a1a1a]/70">
            by <span className="italic-display normal-case tracking-normal text-[13px] md:text-sm text-[#1a1a1a]">Michelle Fragias</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="nav-link text-sm tracking-wide uppercase text-[#1a1a1a]/80 hover:text-[#1a1a1a]">
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#apply" onClick={() => trackEvent("cta_click", { label: "nav_apply_now", location: "navbar" })} className="hidden md:inline-flex btn-primary rounded-full px-5 py-2.5 text-sm tracking-wide uppercase">
          Apply Now
        </a>

        <button aria-label="Menu" className="md:hidden p-2" onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#e9dfce] bg-[#fdfaf5]">
          <div className="px-4 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="text-sm tracking-wide uppercase text-[#1a1a1a]/80" onClick={() => setOpen(false)}>
                {l.label}
              </a>
            ))}
            <a href="#apply" onClick={() => { trackEvent("cta_click", { label: "mobile_nav_apply_now", location: "navbar_mobile" }); setOpen(false); }} className="btn-primary rounded-full px-5 py-2.5 text-sm tracking-wide uppercase text-center">Apply Now</a>
          </div>
        </div>
      )}
    </header>
  );
}
